import {
    Entity,
    PrimaryGeneratedColumn,
    Column,
    CreateDateColumn,
    UpdateDateColumn,
    VersionColumn,
    OneToMany,
    ManyToOne,
    JoinColumn,
  } from "typeorm";
import { LocationsEntity } from "../locations/locations.entity";
import { PlantsEntity } from "../plants/plants.entity";
  
  @Entity("division")
  export class divisionEntity {
    @PrimaryGeneratedColumn({
      name: "id",
    })
    id: number;
  
    @Column("varchar", {
      name: "division",
    })
    division: string;

    // @Column("int", {
    //   name: "plant_id",
    // })
    // plantId: number;
  
  
    @Column("boolean", {
      nullable: false,
      default: true,
      name: "is_active",
    })
    isActive: boolean;
  
    @CreateDateColumn({
      name: "created_at",
      type: "datetime",
    })
    createdAt: Date;
  
    @Column("varchar", {
      nullable: true,
      name: "created_user",
    })
    createdUser: string | null;
  
    @UpdateDateColumn({
      name: "updated_at",
      type: "datetime",
    })
    updatedAt: Date;
  
    @Column("varchar", {
      nullable: true,
      name: "updated_user",
    })
    updatedUser: string | null;
  
    @VersionColumn({
      default: 1,
      name: "version_flag",
    })
    versionFlag: number;

    @OneToMany(() => LocationsEntity, (dpomChild) => { dpomChild.dpom }, { cascade: true })
    dpomChild: LocationsEntity;

    // @ManyToOne(() => PlantsEntity, plant => plant.divisionInfo)
    // @JoinColumn({ name: 'plant_id' })
    // plantsInfo: PlantsEntity;
  }
  